import { render, staticRenderFns } from "./lfmenuitem.vue?vue&type=template&id=4eab73e4&"
import script from "./lfmenuitem.vue?vue&type=script&lang=js&"
export * from "./lfmenuitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "lfmenuitem.vue"
export default component.exports